import { WATCHLISTS_INSTRUMENTS_GET } from '../actions/types';

const initialState = {
  watchlistInstruments: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case WATCHLISTS_INSTRUMENTS_GET._SUCCESS: {
      const { watchlistId, instruments } = action.payload;
      state.watchlistInstruments[watchlistId] = instruments;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as watchlists };
